import type { CriticalMomentsReview, ReviewPlyNote, ReviewPlyNoteInput } from "@chessla/shared";
import { apiClient } from "@/shared/api/client";

export const fetchCriticalMoments = (gameId: string): Promise<CriticalMomentsReview> =>
  apiClient<CriticalMomentsReview>(`/coach/games/${gameId}/critical-moments`);

export const saveReviewReflection = (
  gameId: string,
  factId: string,
  text: string,
): Promise<{ reflection: string | null }> =>
  apiClient<{ reflection: string | null }>(`/coach/games/${gameId}/reflection`, {
    method: "PUT",
    body: JSON.stringify({ factId, text }),
  });

export const fetchReviewPlyNote = (gameId: string, ply: number): Promise<{ note: ReviewPlyNote | null }> =>
  apiClient<{ note: ReviewPlyNote | null }>(`/coach/games/${gameId}/notes/${ply}`);

export const saveReviewPlyNote = (
  gameId: string,
  ply: number,
  input: ReviewPlyNoteInput,
): Promise<{ note: ReviewPlyNote | null }> =>
  apiClient<{ note: ReviewPlyNote | null }>(`/coach/games/${gameId}/notes/${ply}`, {
    method: "PUT",
    body: JSON.stringify(input),
  });
